import { AxiosResponse } from 'axios';

import { IPropertyAttachmentDocument } from '../../components/PropertyAttachmentsField/PropertyAttachmentsMultiFileHandlerField/PropertyAttachmentsMultiFileHandlerField.types';
import { PROPERTY_ATTACHMENT_TYPES } from '../../shared/constants/propertyAttachmentConstants';
import httpRequest from '../httpRequest';

interface GetPropertyAttachmentDocumentTypeParams {
  propertyId?: number;
  type?: PROPERTY_ATTACHMENT_TYPES;
}

interface GetPropertyDocumentParams {
  propertyId: number;
  propertyAttachmentId: string;
}

const propertyAttachmentsAPI = {
  getPropertyAttachmentURL: async ({
    propertyId,
    propertyAttachmentId,
  }: GetPropertyDocumentParams): Promise<string> => {
    const { data } = (await httpRequest({
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
      url: `/properties/${propertyId}/attachments/${propertyAttachmentId}/url`,
      method: 'GET',
    })) as AxiosResponse;

    return data.presigned_url;
  },

  getPropertyAttachmentByType: async ({
    propertyId,
    type,
  }: GetPropertyAttachmentDocumentTypeParams): Promise<
    IPropertyAttachmentDocument[]
  > => {
    const { data } = (await httpRequest({
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
      url: `/properties/${propertyId}/attachments?property_attachment_type=${type}`,
      method: 'GET',
    })) as AxiosResponse;

    return data;
  },

  deletePropertyAttachment: async ({
    propertyId,
    id,
  }: {
    propertyId: number;
    id: string;
  }): Promise<string> => {
    const { data } = (await httpRequest({
      baseURL: process.env.REACT_APP_DALGONA_GW_API_URL,
      url: `/properties/${propertyId}/attachments/${id}`,
      method: 'DELETE',
    })) as AxiosResponse;

    return data;
  },
};

export default propertyAttachmentsAPI;
